import { Col, Typography } from 'antd';
import { confirmation, ProjectsConstructorCard } from '@/components';
import { EpicForm } from './EpicForm';
import { AddEpicDto, EpicDto, ProjectDto } from '@/core';
import { useDeleteEpicMutation, useUpdateEpicMutation } from '@/redux';
import { useTranslation } from 'react-i18next';
import { calculateAffectedByEpicItems } from './helpers/calculateAffectedByEpicItems';

type PropsType = EpicDto & {
  onClickMenuEdit: () => void;
  isEdit: boolean;
  stopEditCard: (id: string) => void;
  projectData: ProjectDto;
};

export const EpicCard = ({
  name,
  description,
  isEdit,
  id,
  onClickMenuEdit,
  stopEditCard,
  projectData,
}: PropsType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [updateEpic] = useUpdateEpicMutation();
  const [deleteEpic] = useDeleteEpicMutation();
  const { affectedProducts, affectedCostTypes, affectedSheets } = calculateAffectedByEpicItems(
    projectData,
    id,
  );

  const submitUpdateEpic = (epicData: AddEpicDto) => {
    updateEpic({ epicData, id })
      .unwrap()
      .then(() => stopEditCard(id));
  };
  const onClickMenuDelete = () =>
    confirmation.show({
      title: t('addEpics.delete.title'),
      body: (
        <div>
          Are you sure you want to delete this Epic? This may affect the report generation. The Epic is used
          for:
          <ul>
            <li>{affectedProducts.length} Product(s)</li>
            <li>{affectedCostTypes.length} Cost Type(s)</li>
            <li>{affectedSheets.length} Sheet(s)</li>
          </ul>
        </div>
      ),
      isConfirmButtonDanger: true,
      onConfirm: () => deleteEpic({ id }),
      confirm: 'Delete',
    });

  return (
    <ProjectsConstructorCard
      isEdit={isEdit}
      onClickMenuDelete={onClickMenuDelete}
      onClickMenuEdit={onClickMenuEdit}
      editForm={
        <EpicForm
          handleCancel={() => stopEditCard(id)}
          handleSubmit={submitUpdateEpic}
          initialValue={{ name, description }}
          formUid={name}
          isCancelButton
          projectData={projectData}
        />
      }
    >
      <Col span={12}>
        <Typography.Paragraph className="pe-3">{name}</Typography.Paragraph>
      </Col>
      <Col span={12}>
        <Typography.Paragraph>{description}</Typography.Paragraph>
      </Col>
    </ProjectsConstructorCard>
  );
};
